import { Observable } from 'rxjs/';
import { Injectable } from '@angular/core';
import { RequestService } from 'app/core/services/request.service';
import { ConfigService } from 'app/core/services/config.service';

@Injectable()
export class TemplatesService {

    constructor(private requestService: RequestService,
                private configService: ConfigService
    ) { }

    getTemplateById(id: string): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').tm.emailTemplate.details.api + '/' + id;
        return this.requestService.get(url);
    }

    getTemplateByKey(key: string): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').tm.emailTemplate.byKey.api + '/' + key;
        return this.requestService.get(url);
    }

    getFieldsByType(type: string): Observable<any> {
        if (type.indexOf('instructor') > -1) {
            return Observable.of(
                [
                    { id: 'class.displayName', label: 'Class Name', placeholder: 'Advanced Android Security Class', required: true },
                    { id: 'class.startDate', label: 'Start Date', placeholder: 'Oct 11 2017', required: true },
                    { id: 'class.endDate', label: 'End Date', placeholder: 'Oct 27 2017', required: true },
                    // { id: 'class.venue.name', label: 'Class Venue', placeholder: 'Google HQ, CA' },
                    // { id: 'class.venue.room', label: 'Room Name at Class Venue', placeholder: 'Room 14A' },
                ]
            );
        }
        return Observable.of(
            [
                // { id: 'class.displayName', label: 'Class Name', placeholder: 'Advanced Android Security Class', required: true },
                // { id: 'class.startDate', label: 'Start Date', placeholder: 'Oct 11 2017', required: true },
                { id: 'class.endDate', label: 'End Date', placeholder: 'Oct 27 2017', required: true },
                { id: 'class.venue.name', label: 'Class Venue', placeholder: 'Google HQ, CA' },
                { id: 'class.venue.room', label: 'Room Name at Class Venue', placeholder: 'Room 14A' },
            ]
        );
    }

    createTemplate(data: any): Observable<any> {
        console.log('data', data)
        let url  =this.configService.get('server').url + this.configService.get('endpoints').tm.emailTemplate.add.api;
        return this.requestService.post(url, data);
    }

    editTemplate(id: string, data: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').tm.emailTemplate.update.api+ '/' + id;
        return this.requestService.post(url, data);
    }

    deleteTemplates(details: Array<any>): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').solar.templates.bulkDelete.api;
        return this.requestService.post(url, details);
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/communication/templates/services/templates.service.ts